import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import CircularProgress from "@mui/material/CircularProgress";

import partCodesService from "services/part-code-service";
import { useEffect, useState } from "react";

import ImageModal from "e4acomponents/ImageModal";
import formatPartCode from "helper/formatPartCode";

export default function PartCodeDetails({ id }) {

    const [partCode, setPartCode] = useState("");
    const [imageUrl, setImageUrl] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [openImageModal, setOpenImageModal] = useState(false);

    // Fetches the partcode and it's image
    useEffect(() => {
        (async () => {
            if (!id) return;
            setIsLoading(true);
            const response = await partCodesService.getPartById(id);
            if (response.data.attributes.has_image) {
                const image = await partCodesService.getImage(response.data.attributes.imagePath);
                setImageUrl(image);
            } else {
                setImageUrl("https://ami-spotlight.footbridge.tilkal.com/resources/images/image.jpg");
            }
            if (partCode) {
                setTimeout(() => setPartCode(response.data.attributes), 500);
            } else {
                setPartCode(response.data.attributes);
            }
        })();
    }, [id]);

    useEffect(() => {
        if (partCode) {
            setIsLoading(false);
        }
    }, [partCode]);
    
    return (

        <Card p={3}>

            <ImageModal
                open={openImageModal}
                onClose={() => setOpenImageModal(false)}
                mediaURL={imageUrl}
            />

            {isLoading ?
                (
                    <MDBox display="flex" justifyContent="center" alignItems="center" height="200px">
                        <CircularProgress />
                    </MDBox>
                ) : (
                    <MDBox p={3}>
                        <MDTypography variant="h4" fontWeight="bold" m={2}>
                            Selected Part Code's Details
                        </MDTypography>

                        <Grid container spacing={3}>
                            <Grid item xs={12} lg={5}>
                                <MDBox
                                    onClick={() => setOpenImageModal(true)}
                                    sx={{ cursor: "pointer", maxWidth: "30vh" }}
                                >
                                    <img src={imageUrl} width="100%" />
                                </MDBox>
                            </Grid>

                            <Grid item xs={12} lg={7} p={2}>

                                {/* Title (Part Code Identifier) */}
                                <MDBox textAlign="center" mb={3}>
                                    <MDTypography variant="h5" fontWeight="medium">
                                        {partCode && (formatPartCode(partCode))}
                                    </MDTypography>
                                </MDBox>

                                {/* Description */}
                                <Grid container spacing={{ xs: 2, md: 4 }} mb={3}>
                                    <Grid item xs={12} md={6}>
                                        <MDTypography variant="h6" fontWeight="medium" textAlign={{ xs: "left", md: "right" }}>
                                            Description
                                        </MDTypography>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <MDTypography variant="h6" fontWeight="regular">
                                            {partCode && (partCode.description)}
                                        </MDTypography>
                                    </Grid>
                                </Grid>
                                {/* Manufacturer */}
                                <Grid container spacing={{ xs: 2, md: 4 }} mb={3}>
                                    <Grid item xs={12} md={6}>
                                        <MDTypography variant="h6" fontWeight="medium" textAlign={{ xs: "left", md: "right" }} mt={2}>
                                            Manufacturer
                                        </MDTypography>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <MDTypography variant="h6" fontWeight="regular" mt={{ xs: 0, md: 2 }}>

                                            {partCode && (partCode.manufacturer ? (partCode.manufacturer) : "N/A")}
                                        </MDTypography>
                                    </Grid>
                                </Grid>

                                {/* Manufacturer Part Number */}
                                <Grid container spacing={{ xs: 2, md: 4 }} mb={3}>
                                    <Grid item xs={12} md={6}>
                                        <MDTypography variant="h6" fontWeight="medium" textAlign={{ xs: "left", md: "right" }} mt={2}>
                                            Manufacturer Part Number
                                        </MDTypography>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <MDTypography variant="h6" fontWeight="regular" mt={{ xs: 0, md: 2 }}>
                                            {partCode && (partCode.manufacturer_part_number ? (partCode.manufacturer_part_number) : "N/A")}
                                        </MDTypography>
                                    </Grid>
                                </Grid>

                                {/* Vendor */}
                                <Grid container spacing={{ xs: 2, md: 4 }} mb={3}>
                                    <Grid item xs={12} md={6}>
                                        <MDTypography variant="h6" fontWeight="medium" textAlign={{ xs: "left", md: "right" }} mt={2}>
                                            Vendor
                                        </MDTypography>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <MDTypography variant="h6" fontWeight="regular" mt={{ xs: 0, md: 2 }}>
                                            {partCode && (partCode.vendors ? (partCode.vendors[`vendor-1`]) : "N/A")}
                                        </MDTypography>
                                    </Grid>
                                </Grid>

                                {/* Vendor Part Number */}
                                <Grid container spacing={{ xs: 2, md: 4 }} mb={3}>
                                    <Grid item xs={12} md={6}>
                                        <MDTypography variant="h6" fontWeight="medium" textAlign={{ xs: "left", md: "right" }} mt={2}>
                                            Vendor Part Number
                                        </MDTypography>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <MDTypography variant="h6" fontWeight="regular" mt={{ xs: 0, md: 2 }}>
                                            {partCode && (partCode.vendor_part_number ? (partCode.vendor_part_number) : "N/A")}
                                        </MDTypography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </MDBox>
                )}
        </Card>

    )
}